import React from "react";

function NoDataCard() {
  return (
    <div
      style={{
        width: "100%",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      <img
        src={require("../../../../../assets/img/ic_search_empty@2x.png")}
        height={140}
        style={{ marginTop: "25px" }}
      />
      <div style={{ fontSize: "0.875rem", fontWeight: "500",marginTop:"15px" }}>
        <b>No Results Found</b>
      </div>
      <div style={{ fontSize: "0.7rem", fontWeight: "500" }}>
        No matching entries available in our record
      </div>
    </div>
  );
}

export default NoDataCard;
